var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"src":_vm.src || _vm.asset('/img/avatar_default_user.png'),"onerror":'this.onerror=null; this.src=\'' + _vm.asset('/img/avatar_default_user.png') + '\''}})}
var staticRenderFns = []

export { render, staticRenderFns }